/* Joe Luxe product page — additive only, works on top of the theme's own gallery
   and cart form. Labels studio vs real photos, adds Studio / Real photos jump tabs
   on phones, and a slim Add-to-cart bar once the main button scrolls away. */
(function () {
  if (window.__jlPdp) return;
  window.__jlPdp = true;

  var REAL = /_real_/i;

  function isReal(el) {
    var img = el.querySelector('img');
    return !!img && REAL.test(img.getAttribute('src') || '');
  }

  function chip(el, real) {
    if (el.querySelector('.jl-pdp-chip')) return;
    var s = document.createElement('span');
    s.className = 'jl-pdp-chip' + (real ? ' jl-pdp-chip--real' : '');
    s.textContent = real ? 'Real photo · unedited' : 'Studio image';
    el.appendChild(s);
  }

  function scroller(el) {
    var n = el.parentElement;
    while (n && n !== document.body) {
      var o = getComputedStyle(n).overflowX;
      if (o === 'auto' || o === 'scroll') return n;
      n = n.parentElement;
    }
    return null;
  }

  function gallery() {
    var g = document.querySelector('media-gallery');
    if (!g) return;
    var slides = Array.prototype.slice.call(g.querySelectorAll('slideshow-slide'));
    var cells = g.querySelectorAll('.media-gallery__grid > li');
    var firstReal = -1;
    var realCount = 0;

    slides.forEach(function (s, i) {
      var real = isReal(s);
      chip(s, real);
      if (real) {
        realCount++;
        if (firstReal < 0) firstReal = i;
      }
    });
    Array.prototype.forEach.call(cells, function (c) {
      chip(c, isReal(c));
    });

    /* Tabs only when the gallery opens on a studio image and has real photos after it */
    var ss = g.querySelector('slideshow-component');
    if (!ss || firstReal < 1) return;
    var track = scroller(slides[0]);
    if (!track) return;

    var tabs = document.createElement('div');
    tabs.className = 'jl-pdp-tabs';
    tabs.setAttribute('role', 'group');
    tabs.setAttribute('aria-label', 'Photos');
    tabs.innerHTML =
      '<button type="button" class="jl-pdp-tab is-on" data-i="0">Studio</button>' +
      '<button type="button" class="jl-pdp-tab" data-i="' + firstReal + '">Real photos · ' + realCount + '</button>';
    ss.insertAdjacentElement('afterend', tabs);
    var btns = tabs.querySelectorAll('.jl-pdp-tab');

    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('.jl-pdp-tab');
      if (!b) return;
      var s = slides[+b.getAttribute('data-i')];
      track.scrollTo({ left: s.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var real = slides.indexOf(e.target) >= firstReal && isReal(e.target);
          btns[0].classList.toggle('is-on', !real);
          btns[1].classList.toggle('is-on', real);
        });
      },
      { threshold: 0.6 }
    );
    slides.forEach(function (s) {
      io.observe(s);
    });
  }

  function bar() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var main = form && form.querySelector('.add-to-cart-button');
    var meta = document.querySelector('.jl-pdp-meta');
    if (!main || !meta || !('IntersectionObserver' in window)) return;

    var el = document.createElement('div');
    el.className = 'jl-pdp-bar';
    var price = document.createElement('span');
    price.className = 'jl-pdp-bar__price';
    price.textContent = meta.getAttribute('data-price') || '';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'jl-pdp-bar__btn';
    btn.textContent = (main.textContent || '').replace(/\s+/g, ' ').trim() || 'Add to cart';
    btn.disabled = main.disabled;
    btn.addEventListener('click', function () {
      main.click(); /* the theme's own form handles the cart */
    });
    el.appendChild(price);
    el.appendChild(btn);
    document.body.appendChild(el);

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      el.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(main);
  }

  /* "Hold to look closer": a round loupe over the product photo. Touch = press and
     hold (a swipe still changes photo, a tap still opens the theme's zoom), mouse =
     follows the cursor (a click still opens the theme's zoom). The lens and the
     enlarged photo inside it move by transform only; the sharp image loads on first use. */
  var LOUPE_ZOOM = 2.5;
  var LOUPE_HOLD = 260;   /* ms before a still finger becomes the loupe */
  var LOUPE_SLOP = 8;     /* px a finger may drift before it counts as a swipe */

  function loupe() {
    var g = document.querySelector('media-gallery');
    if (!g) return;

    var lens = document.createElement('div');
    lens.className = 'jl-loupe';
    lens.setAttribute('aria-hidden', 'true');
    var big = document.createElement('img');
    big.alt = '';
    big.decoding = 'async';
    lens.appendChild(big);
    document.body.appendChild(lens);

    var size = 0, img = null, rect = null, active = false, touch = false;
    var timer = 0, sx = 0, sy = 0, swallowClick = false, frame = 0, px = 0, py = 0;

    function sharp(el) {
      var w = Math.min(2400, Math.round(el.getBoundingClientRect().width * LOUPE_ZOOM * (window.devicePixelRatio || 1)));
      var src = el.currentSrc || el.src || '';
      return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + w) : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
    }

    function photoAt(target) {
      var c = target.closest && target.closest('.product-media-container');
      if (!c || c.closest('.dialog-zoomed-gallery')) return null;
      var el = c.querySelector('.product-media img');
      return el && el.complete !== false ? el : null;
    }

    function place() {
      frame = 0;
      if (!active) return;
      var x = Math.max(0, Math.min(rect.width, px - rect.left));
      var y = Math.max(0, Math.min(rect.height, py - rect.top));
      /* finger: lens floats above it; mouse: lens sits on the cursor */
      var lx = px - size / 2;
      var ly = touch ? py - size - 28 : py - size / 2;
      lens.style.transform = 'translate3d(' + lx + 'px,' + ly + 'px,0)';
      big.style.transform = 'translate3d(' + (size / 2 - x * LOUPE_ZOOM) + 'px,' + (size / 2 - y * LOUPE_ZOOM) + 'px,0)';
    }

    function move(x, y) {
      px = x;
      py = y;
      if (!frame) frame = requestAnimationFrame(place);
    }

    function open(el, x, y, byTouch) {
      img = el;
      touch = byTouch;
      rect = el.getBoundingClientRect();
      size = Math.round(Math.min(180, Math.max(120, rect.width * 0.42)));
      lens.style.width = lens.style.height = size + 'px';
      big.style.width = rect.width * LOUPE_ZOOM + 'px';
      big.style.height = rect.height * LOUPE_ZOOM + 'px';
      var s = sharp(el);
      if (big.getAttribute('src') !== s) {
        big.src = el.currentSrc || el.src; /* instant, then swap to the sharp copy */
        var hi = new Image();
        hi.onload = function () { if (img === el) big.src = s; };
        hi.src = s;
      }
      active = true;
      lens.classList.add('is-on');
      move(x, y);
      if (byTouch) {
        g.classList.add('jl-loupe-used');
        try { localStorage.setItem('jl-loupe-used', '1'); } catch (e) {}
      }
    }

    function close() {
      active = false;
      img = null;
      lens.classList.remove('is-on');
    }

    /* Touch: hold still to open; moving first means a swipe or scroll */
    g.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      var el = photoAt(e.target);
      if (!el) return;
      var t = e.touches[0];
      sx = t.clientX;
      sy = t.clientY;
      clearTimeout(timer);
      timer = setTimeout(function () {
        swallowClick = true;
        open(el, sx, sy, true);
      }, LOUPE_HOLD);
    }, { passive: true });

    g.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (active && touch) {
        e.preventDefault(); /* the loupe owns this gesture: no scroll, no slide */
        move(t.clientX, t.clientY);
      } else if (timer && (Math.abs(t.clientX - sx) > LOUPE_SLOP || Math.abs(t.clientY - sy) > LOUPE_SLOP)) {
        clearTimeout(timer);
        timer = 0;
      }
    }, { passive: false });

    function endTouch() {
      clearTimeout(timer);
      timer = 0;
      if (active && touch) close();
    }
    g.addEventListener('touchend', endTouch);
    g.addEventListener('touchcancel', endTouch);

    /* After a hold, the lifted finger must not also open the theme's zoom */
    g.addEventListener('click', function (e) {
      if (!swallowClick) return;
      swallowClick = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
    g.addEventListener('contextmenu', function (e) {
      if (photoAt(e.target) && (timer || active)) e.preventDefault();
    });

    /* Mouse: follow the cursor over the photo */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      g.addEventListener('mousemove', function (e) {
        var el = photoAt(e.target);
        if (!el) {
          if (active && !touch) close();
          return;
        }
        if (!active || img !== el) open(el, e.clientX, e.clientY, false);
        else move(e.clientX, e.clientY);
      });
      g.addEventListener('mouseleave', function () {
        if (active && !touch) close();
      });
      window.addEventListener('scroll', function () {
        if (active && !touch) close();
      }, { passive: true });
    }

    /* One quiet hint on the first photo for touch visitors who haven't used it yet */
    var seen = false;
    try { seen = localStorage.getItem('jl-loupe-used') === '1'; } catch (e) {}
    if (seen) g.classList.add('jl-loupe-used');
    var first = g.querySelector('.product-media-container');
    if (first && !first.querySelector('.jl-loupe-hint')) {
      var hint = document.createElement('span');
      hint.className = 'jl-loupe-hint';
      hint.textContent = 'Hold to look closer';
      first.appendChild(hint);
    }
  }

  function init() {
    gallery();
    bar();
    loupe();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
